import { render } from "./CheckoutPage.vue?vue&type=template&id=23137358&scoped=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&lang=js"

import "./CheckoutPage.vue?vue&type=style&index=0&id=23137358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23137358"]])

export default __exports__